<template>
    <AlertHistory/>
</template>

<script>
import AlertHistory from "@/components/Alert/AlertHistory.vue";

export default {
  name: "ZoneGeofenceHistory",
  components: {AlertHistory}
};
</script>

<style scoped>

</style>